<template>
    <transition name="modal-bounce">
        <div class="modal fade show" v-if="modelValue" style="display: block;" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content bg-light-gray">
                    <div class="modal-header">
                        <h5 class="modal-title">生命體徵紀錄 ({{ timeLabel }})</h5>
                        <button type="button" class="btn-close" @click="closeModal"></button>
                    </div>
                    <div class="modal-body p-4">
                        <div>
                            <div class="mb-3 mb-xl-3">
                                <div class="input-range-label">
                                    <label class="form-label">Iso</label>
                                    <input type="number" class="form-control form-control-sm w-25 text-end vital-input" placeholder="N/A" v-model.number="formData.Iso" :min="0" :max="5" :step="0.25">
                                </div>
                                <input
                                    type="range" class="form-range" 
                                    :min="0" 
                                    :max="5" 
                                    :step="0.25" 
                                    v-model="formData.Iso"
                                >
                                <div class="d-flex justify-content-between range-scale">
                                    <span v-for="tick in generateTicks(0, 5, 1)" :key="tick">{{ tick }}</span>
                                </div>
                            </div>
                            <div class="mb-3 mb-xl-3">
                                <div class="mb-3 mb-xl-3">
                                    <div class="input-range-label">
                                        <label class="form-label">SpO2(%)</label>
                                        <input type="number" class="form-control form-control-sm w-25 text-end vital-input" placeholder="N/A" v-model.number="formData.SpO2" :min="0" :max="100" :step="1">
                                    </div>
                                    <input type="range" class="form-range" 
                                        :min="0" 
                                        :max="100" 
                                        :step="1" 
                                        v-model="formData.SpO2"
                                    >
                                    <div class="d-flex justify-content-between range-scale">
                                        <span v-for="tick in generateTicks(0, 100, 10)" :key="tick">{{ tick }}</span>
                                    </div>
                                </div>
                                
                            </div>
                            <div class="mb-3 mb-xl-3">
                                <div class="mb-3 mb-xl-3">
                                    <div class="input-range-label">
                                        <label class="form-label">EtCO2</label>
                                        <input type="number" class="form-control form-control-sm w-25 text-end vital-input" placeholder="N/A" v-model.number="formData.EtCO2" :min="0" :max="100" :step="1">
                                    </div>
                                    <input type="range" class="form-range" 
                                        :min="0" 
                                        :max="100" 
                                        :step="1" 
                                        v-model="formData.EtCO2"
                                    >
                                    <div class="d-flex justify-content-between range-scale">
                                        <span v-for="tick in generateTicks(0, 100, 10)" :key="tick">{{ tick }}</span>
                                    </div>
                                </div>

                            </div>
                            <div class="mb-3 mb-xl-3">
                                <div class="mb-3 mb-xl-3">
                                    <div class="input-range-label">
                                        <label class="form-label">HR</label>
                                        <input type="number" class="form-control form-control-sm w-25 text-end vital-input" placeholder="N/A" v-model.number="formData.HR" :min="0" :max="500" :step="1">
                                    </div>
                                    <input type="range" class="form-range" 
                                        :min="0" 
                                        :max="500" 
                                        :step="1" 
                                        v-model="formData.HR"
                                    >
                                    <div class="d-flex justify-content-between range-scale">
                                        <span v-for="tick in generateTicks(0, 500, 50)" :key="tick">{{ tick }}</span>
                                    </div>
                                </div>

                            </div>
                            <div class="mb-3 mb-xl-3">
                                <div class="mb-3 mb-xl-3">
                                    <div class="input-range-label">
                                        <label class="form-label">RR</label>
                                        <input type="number" class="form-control form-control-sm w-25 text-end vital-input" placeholder="N/A" v-model.number="formData.RR" :min="0" :max="100" :step="1">
                                    </div>
                                    <input type="range" class="form-range" 
                                        :min="0" 
                                        :max="100" 
                                        :step="1" 
                                        v-model="formData.RR"
                                    >
                                    <div class="d-flex justify-content-between range-scale">
                                        <span v-for="tick in generateTicks(0, 100, 10)" :key="tick">{{ tick }}</span>
                                    </div>
                                </div>

                                
                            </div>
                            <div class="mb-3 mb-xl-3">
                                <div class="input-range-label">
                                    <label class="form-label">BT</label>
                                    <input type="number" class="form-control form-control-sm w-25 text-end vital-input" placeholder="N/A" v-model.number="formData.BT" :min="20" :max="45" :step="0.25">
                                </div>
                                <input type="range" class="form-range" 
                                    :min="20" 
                                    :max="45" 
                                    :step="0.25" 
                                    v-model="formData.BT"
                                >
                                <div class="d-flex justify-content-between range-scale">
                                    <span v-for="tick in generateTicks(20, 45, 5)" :key="tick">{{ tick }}</span>
                                </div>
                            </div>
                            <div class="mb-3 mb-xl-3">
                                <div class="input-range-label">
                                    <label class="form-label">SYS</label>
                                    <input type="number" class="form-control form-control-sm w-25 text-end vital-input" placeholder="N/A" v-model.number="formData.SYS" :min="0" :max="250" :step="1">
                                </div>
                                <input type="range" class="form-range" 
                                    :min="0" 
                                    :max="250" 
                                    :step="1"  
                                    v-model="formData.SYS"
                                >
                                <div class="d-flex justify-content-between range-scale">
                                    <span v-for="tick in generateTicks(0, 250, 25)" :key="tick">{{ tick }}</span>
                                </div>
                            </div>
                            <div class="mb-3 mb-xl-3">
                                <div class="input-range-label">
                                    <label class="form-label">DIA</label>
                                    <input type="number" class="form-control form-control-sm w-25 text-end vital-input" placeholder="N/A" v-model.number="formData.DIA" :min="0" :max="150" :step="1">
                                </div>
                                <input type="range" class="form-range" 
                                    :min="0" 
                                    :max="150" 
                                    :step="1" 
                                    v-model="formData.DIA"
                                >
                                <div class="d-flex justify-content-between range-scale">
                                    <span v-for="tick in generateTicks(0, 150, 25)" :key="tick">{{ tick }}</span>
                                </div>
                            </div>
                            <div class="mb-3 mb-xl-3">
                                <div class="input-range-label">
                                    <label class="form-label">MAP</label>
                                    <span class="form-control form-control-sm w-25 text-end vital-input" style="border: 1px solid #ced4da; background-color: #e9ecef;">{{ formData.MAP ? formData.MAP : 'N/A' }}</span>
                                </div>
                                <!-- <input type="range" class="form-range" 
                                    min="0" 
                                    max="100" 
                                    step="0.5" 
                                    v-model="formData.MAP"
                                >
                                -->
                            </div>
                            <div class="mb-3 mb-xl-3">
                                

                                <div class="input-range-label">
                                    <label class="form-label">Fluid rate (ml/h)</label>
                                    <input type="number" class="form-control form-control-sm w-25 text-end vital-input" placeholder="N/A" v-model.number="formData.Fluid_rate">
                                </div>
                                <!-- <input type="range" class="form-range" 
                                    :min="0" 
                                    :max="50" 
                                    :step="0.1"  
                                    v-model="formData.Fluid_rate"
                                > -->
                                
                            </div>
                            <div class="mb-3 mb-xl-3">
                                <label class="form-label">Event</label>
                                <input class="form-control" type="text"
                                    v-model="formData.Event"
                                />

                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="row w-100">
                             <div class="col-4">
                                <button class="btn btn-outline-success w-100" @click="closeModal">
                                    <span>略過</span>
                                </button>
                            </div>
                            <div class="col-8">
                                <button class="btn btn-success w-100" @click="saveData">
                                    <span>＋添加生命體徵紀錄</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'SurgeryVitalSignModal',
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        currentTime: {
            type: Number,
            default: 0
        },
        lastData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            formData: {
                BT: 36,
                DIA: 80,
                EtCO2: 35,
                Fluid_rate: 0,
                HR: 100,
                Iso: null,
                MAP: 0,
                RR: 20,
                SYS: 120,
                SpO2: 95,
                Event: '',
            }
        }
    },
    computed: {
        timeLabel() {
            const h = Math.floor(this.currentTime / 3600)
            const m = Math.floor((this.currentTime % 3600) / 60)
            const s = this.currentTime % 60
            const mStr = String(m).padStart(2, '0')
            const sStr = String(s).padStart(2, '0')
            
            if (h > 0) {
                 return `${h}:${mStr}:${sStr}`
             }
            return `${mStr}:${sStr}`
        }
    },
    watch: {
        modelValue(val) {
            if (val) {
                // Initialize with last data but clear event
                this.formData = {
                    ...this.lastData,
                    Event: ''
                }
            }
        },
        'formData.SYS'() { this.calculateMAP() },
        'formData.DIA'() { this.calculateMAP() }
    },
    methods: {
        closeModal() {
            this.$emit('update:modelValue', false)
        },
        calculateMAP() {
            const sys = parseFloat(this.formData.SYS) || 0
            const dia = parseFloat(this.formData.DIA) || 0
            if (sys > 0 && dia > 0) {
                this.formData.MAP = (dia + (1/3) * (sys - dia)).toFixed(1)
            }
        },
        saveData() {
            this.$emit('save', {
                type: 'vital-sign',
                data: { ...this.formData },
                timeSeconds: this.currentTime,
                timeLabel: this.timeLabel
            })
            this.closeModal()
        },
        generateTicks(min, max, step) {
            const ticks = []
            for (let i = min; i <= max; i += step) {
                ticks.push(i)
            }
            return ticks
        }
    }
}
</script>

<style scoped>
.range-value {
    font-size: 1.2rem;
}

/* Modal Animation */
.modal-bounce-enter-active, .modal-bounce-leave-active {
    transition: opacity 0.3s ease;
}
.modal-bounce-enter-from, .modal-bounce-leave-to {
    opacity: 0;
}

.modal-bounce-enter-active .modal-content {
    animation: slide-down 0.4s ease-out;
}
.modal-bounce-leave-active .modal-content {
    /* No slide up on leave, just fade out whole modal or reverse animation */
    /* Use reverse if we want slide up, but user complained about "sliding range". 
       Let's stick to simple fade out or keep reverse but ensure root doesn't move */
    animation: slide-down 0.3s ease-in reverse;
}


.input-range-label{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}
.range-scale span {
    font-size: 12px;
    color: #bcbcbd;
}
.range-value{
    font-size: 1.5rem;
    font-weight: 900;
    color: #6f42c1;
}
/* Custom Slider Thumb - Triangle */
.form-range::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  background-color: #6f42c1;
  clip-path: polygon(50% 100%, 0 0, 100% 0); /* Inverted Triangle */
  border-radius: 0;
  cursor: pointer;
  position: relative;
  margin-top: -6px; /* Center alignment adjustment if needed */
}
.vital-input {
    color: #6f42c1;
    font-weight: 700; /* Bold */
}
@keyframes slide-down {
    0% {
        transform: translateY(-50px); /* Start slightly above, not full -100% which is offscreen */
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
}
</style>
